import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { styles as flexboxHelpersStyles } from '../../../../../assets/flexbox-helpers.scss';
import { styles as fonts } from '../../../../../assets/fonts.scss';
import { styles as styleHelpersStyles } from '../../../../../assets/style-helpers.scss';

export const installAgentAdditionalTargetsForm = document.createElement('template');

installAgentAdditionalTargetsForm.innerHTML = `
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${fonts}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class='form-wrapper' id='additional-targets-form-wrapper'>
    <div class='form-section'>
      <gz-accordion id='additional-targets-section' removeTitlePadding customTitleFontSize='11' removeContentPadding>
        <gz-form-field id='targets-hostname-ip-form-field' class='remove-content-form-margin'>
          <gz-chips-generator-input customFormSizing gz-form-input inputWidth='480'></gz-chips-generator-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </gz-accordion>
      <gz-info-box class='info-box-style'></gz-info-box>
    </div>
  </div>
`;
